module.exports = __webpack_public_path__ + "img/no-imagestyles.e2e9334c.svg";